import { updateBusinessEntity } from '@commenda/api';
import { CheckedGreenBackgroundSquare } from '@commenda/icons';
import {
  Button,
  Icons,
  Input,
  InputErrorMessage,
  Label,
} from '@commenda/kakashi';
import React from 'react';
import { FormInputWrapper } from '../../../../../incorporation';

const GetNameReservationForm = ({
  corporationId,
  taskID,
  taskGroupID,
  companyLegalName,
  setOpen,
  onSuccessCallback,
}: {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  corporationId: number;
  companyLegalName: string;
  taskID: number;
  taskGroupID: number;
  onSuccessCallback?: () => void;
}) => {
  const [corporationName, setCorporationName] =
    React.useState(companyLegalName);
  const [error, setError] = React.useState('');

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!corporationName || corporationName.trim() === '') {
      setError('Please enter a corporation name');
      return;
    }

    setError('');

    const updateNameRes = await updateBusinessEntity(corporationId, {
      legalName: corporationName,
    });

    if (!updateNameRes.ok) {
      console.log('Error: ', updateNameRes);
      return;
    }

    // Now mark the step as completed in the backend
    if (onSuccessCallback) onSuccessCallback();

    setOpen(false);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCorporationName(e.target.value);
    if (error) setError('');
  };

  return (
    <form
      onSubmit={onSubmit}
      className="flex flex-col gap-4 overflow-y-auto max-w-[574px] px-8 py-7 relative"
    >
      <div className="absolute left-7 top-5">
        <CheckedGreenBackgroundSquare className="w-8 h-8" />
      </div>
      <div className="h-12" />
      <FormInputWrapper
        id="corporationName"
        text="Name of corporation"
        description="The name you enter here will also update the name of the corporation."
      >
        <div className="flex flex-col gap-1">
          <Label className="text-sm text-neutral-1">
            <span>Name of corporation</span>
          </Label>
          <Input
            placeholder="Corporation name..."
            onChange={handleInputChange}
            defaultValue={corporationName}
          />
          {error && <InputErrorMessage message={error} />}
        </div>
      </FormInputWrapper>
      <div className="flex justify-end">
        <Button type="submit" variant="primary">
          <span className="flex items-center gap-1">
            <Icons.Check /> Mark as filed
          </span>
        </Button>
      </div>
    </form>
  );
};

export default GetNameReservationForm;
